import { useCallback, useContext } from "react";
import { LocaleContext } from "../LocaleProvider";
export const useLocaleString = (
  localeStrings: Record<string, Record<string, string>>,
) => {
  const locale = useContext(LocaleContext);
  const getLocaleString = useCallback(
    (string: string): string => {
      if (locale in localeStrings[string]) {
        return localeStrings[string][locale];
      } else if (locale.split("-")[0] in localeStrings[string]) {
        return localeStrings[string][locale.split("-")[0]];
      }
      return localeStrings[string].en;
    },
    [locale, localeStrings],
  );
  return getLocaleString;
};
